<!-- src/components/Toggle.vue -->
<template>
  <div class="toggle-container d-flex">
    <h6 class="mb-0">{{ label }}</h6>
    <div class="form-check form-switch ps-0 ms-auto my-auto">
      <input class="form-check-input" type="checkbox" :checked="modelValue" @click="toggle" />
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  label: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["update:modelValue"]);

function toggle() {
  emit("update:modelValue", !props.modelValue);
}
</script>

<style scoped>
.toggle-container {
  display: flex;
  align-items: center;
}

.form-check-input {
  cursor: pointer;
}
</style>
